export default __webpack_public_path__ + "static/media/blog-ads.53262c46.png";